import Market from '@root/core/src/models/market';
import React from '@root/vendor/react';
import { P2 } from '@root/gatsby-contentful-core/src/components/text';
import { StyleSheet } from '@root/core/src/utils/styles';

export default function ProductAvailabilityContent({
  formattedMarketData,
  products,
}) {
  if (formattedMarketData?.auto || formattedMarketData?.renters || formattedMarketData?.homeowners) {
    return (
      <>
        <P2 css={styles.tooltipTitle}>{Market.MAPPING[formattedMarketData.market]}</P2>

        {products.includes('auto') && <p>{`Auto: ${formattedMarketData.auto}`}</p>}
        {products.includes('renters') && <p>{`Renters: ${formattedMarketData.renters}`}</p>}
        {products.includes('homeowners') && <p>{`Homeowners: ${formattedMarketData.homeowners}`}</p>}
      </>
    );
  } else {
    return <p css={styles.notAvailableMessage}>{`Sorry, Root isn't available in ${Market.MAPPING[formattedMarketData?.market] || 'this state'} yet.`}</p>;
  }
}

const styles = StyleSheet.create({});
